import React, { forwardRef } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';
const badgeVariants = cva('inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2', {
  variants: {
    variant: {
      default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
      secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
      destructive: 'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
      success: 'border-transparent bg-success/15 text-success',
      warning: 'border-transparent bg-warning/20 text-warning-foreground',
      info: 'border-transparent bg-info/15 text-info',
      outline: 'text-foreground',
    },
    size: {
      sm: 'px-2 py-0.5 text-[11px]',
      md: 'px-2.5 py-1 text-xs',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'md',
  },
});
export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}
const Badge = forwardRef<HTMLDivElement, BadgeProps>(({
  className,
  variant,
  size,
  ...props
}, ref) => {
  return <div ref={ref} className={cn(badgeVariants({
    variant,
    size,
  }), className)} {...props} />;
});
Badge.displayName = 'Badge';
export { Badge, badgeVariants };